module.exports = __webpack_public_path__ + "img/DE.cfb71af7.png";